document.addEventListener('DOMContentLoaded', function() {
  const links = document.querySelectorAll('.anchor-links__sticky button[data-section]');
  window.addEventListener('scroll', () => {
    const fromTop = window.scrollY;
    const announcementContainerHeight = document.querySelector(".announcement-bar").clientHeight || 0
    const headerContainerHeight = document.querySelector(".section-header")?.clientHeight || 0;
    const headerOffset = headerContainerHeight + announcementContainerHeight + document.querySelector('.anchor-links__sticky').clientHeight;
    links.forEach(link => {
      const sectionElements = document.querySelectorAll(`[data-anchor="${link.dataset.section}"]`);
      let isActive = false;
      sectionElements.forEach(sec => {
        const closestSection = sec.closest(".shopify-section");
        if (closestSection) {
          const top = closestSection.offsetTop - headerOffset;
          const bottom = closestSection.offsetTop + closestSection.clientHeight - headerOffset;
          if (fromTop >= top && fromTop < bottom) {
            isActive = true;
          }
        }
      });
      if (isActive) { 
        link.classList.add('active');
        const htab_container = document.querySelector('.anchor-links__list');
        const htab_tabRect = link.getBoundingClientRect();
        const htab_containerRect = htab_container.getBoundingClientRect();
        const scrollLeft = htab_container.scrollLeft + (htab_tabRect.left - htab_containerRect.left) - (htab_containerRect.width / 2 - htab_tabRect.width / 2);
        htab_container.scrollTo({
          left: scrollLeft
        });        
       }else { link.classList.remove('active'); }
    });
  });
  

  if( document.querySelectorAll('a.image-content__button').length > 0 ){
    document.querySelectorAll('a.image-content__button').forEach(link => {
      link.addEventListener('click', event => {
        event.preventDefault();
        let lastSlashIndex = event.currentTarget.href.lastIndexOf('/');
        if (lastSlashIndex !== -1) {
            let pathAnchor = event.currentTarget.href.substring(lastSlashIndex + 1);
            const targetElement = document.querySelector(`[data-anchor="${pathAnchor}"]`);
            const sectionHeader = document.querySelector('.section-header');
            if (!targetElement || !sectionHeader) return;
            const totalTop = sectionHeader.clientHeight + document?.querySelector('[data-section-type="page-anchor-links"]')?.clientHeight;
            window.scrollTo({
              top: targetElement.offsetTop - totalTop,
              behavior: 'smooth'
            });
        }        
      });
    });
  }
  
  if( document.querySelectorAll('.squeeze_scroller_item').length > 0 ){
    const scrollingContent = document.getElementById("scrollingContent");
    scrollingContent.innerHTML += scrollingContent.innerHTML;
    let x = 0;
    let scrollSpeed = 0.4;
    let isPaused = false;
    function animate() {
      if (!isPaused) {
        x -= scrollSpeed;
        if (Math.abs(x) >= scrollingContent.scrollWidth / 2) {
          x = 0;
        }
        scrollingContent.style.transform = `translateX(${x}px)`;
      }
      requestAnimationFrame(animate);
    }
    document.querySelector(".squeeze_scroller_main").addEventListener("mouseenter", () => isPaused = true);
    document.querySelector(".squeeze_scroller_main").addEventListener("mouseleave", () => isPaused = false);
    animate();  
  }  

  const REVIEW_API_BASE = 'https://api.okendo.io/v1';
  const STORE_ID = 'ddccf316-2614-49f7-8641-7b411da6bacb';
  const COLLECTION_ID = 'c95c5011-c412-4f6c-bc87-cdb7a8e9b16e';
  const INITIAL_API_URL = `${REVIEW_API_BASE}/stores/${STORE_ID}/collections/${COLLECTION_ID}/reviews`;
  const loadMoreReviewsBtn = document.getElementById('load-more-reviews');
  const reviewContainer = document.getElementById('chronic-review-container');
  let nextUrl = null;
  
  function toggleLoadMore(url) {
    if (!loadMoreReviewsBtn) return;
    loadMoreReviewsBtn.classList.toggle('hidden', !url);
  }
  
  function createReviewItem(item) {
    const gridItem = document.createElement('div');
    gridItem.className = 'review-grid-item';
    const avatarUrl = item?.reviewer?.avatarUrl || item?.productImageUrl || '';
    const avatarAlt = item?.reviewer?.displayName || item?.productName || 'avatar';
    const avatar = `<img style="width: 72px; height: 72px; object-fit: cover; border-radius: 5px;" alt="${avatarAlt}" src="${avatarUrl}"> `;
    const ratingPercent = `${(item?.rating || 0) * 20}%`;
    gridItem.innerHTML = `
      <span class="okeReviews-starRating-indicator" role="presentation rating-${item?.rating}">
        <span class="okeReviews-starRating-indicator-layer"></span>
        <span class="okeReviews-starRating-indicator-layer okeReviews-starRating-indicator-layer--foreground" style="width: ${ratingPercent}"></span>
      </span>
      <h3>${item?.title || ''}</h3>
      <p>${item?.body || ''}</p>
      <p style="display: flex; align-items: center; gap: 16px;">${avatar}<span>${item?.reviewer?.displayName || ''}</span></p>
    `;
    return gridItem;
  }
  
  function loadReviews(data, setPosition = false) {
    const reviews = data?.reviews;
    if (!reviews?.length || !reviewContainer) return;
    const fragment = document.createDocumentFragment();
    reviews.forEach(item => {
      const reviewEl = createReviewItem(item);
      fragment.appendChild(reviewEl);
    });
    reviewContainer.appendChild(fragment);
    if (setPosition) {
      const promoBanner = reviewContainer.querySelector('.promo__banner');
      const thirdReview = reviewContainer.querySelectorAll('.review-grid-item')[2];
      if (promoBanner && thirdReview) {
        reviewContainer.insertBefore(promoBanner, thirdReview);
      }
    }
    nextUrl = data?.nextUrl ? `${REVIEW_API_BASE}${data.nextUrl}` : null;
    toggleLoadMore(nextUrl);
  }
  
  async function fetchReviews(url = INITIAL_API_URL) {
    try {
      const response = await fetch(url);
      return await response.json();
    } catch (error) {
      console.error('Error fetching reviews:', error);
      return null;
    }
  }
  
  (async () => {
    const data = await fetchReviews();
    if (data) {
      loadReviews(data, true);
    }
  })();
  
  if (loadMoreReviewsBtn) {
    loadMoreReviewsBtn.addEventListener('click', async () => {
      if (!nextUrl) return;
      loadMoreReviewsBtn.disabled = true;
      const moreData = await fetchReviews(nextUrl);
      if (moreData) {
        loadReviews(moreData);
      }
      loadMoreReviewsBtn.disabled = false;
    });
  }

})